export default "__VITE_ASSET__BJYXp7fc__"